import React, {useContext, useState} from 'react';
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Input from "@amzn/meridian/input";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import { injectIntl} from "react-intl";
import Column from "@meridian/components/column";
import Text from "@amzn/meridian/text";
import Alert from "@amzn/meridian/alert"
import {
    checkModalValidationsForConfig, isValidEntry, PATTERNS
} from "../../../util/Validations";
import {
    AUTO_LOADER_ASSET_TYPE, CATCH_ALL_INSTALLATION_TYPES,
    CONFIG_TYPE, INSTALLATION_TYPES,
} from "../../../util/Constants";
import {DraftContext} from "../../../draftSave/context/DraftSaveContext";
import Select, {SelectOption} from "@amzn/meridian/select";
import {
    getAutoLoaderConfigKey, getInstallationTypes, getAutoLoaderConfigLocationStringForm
} from "../../../util/Util";
import {getLocalizedMessage} from "../../../util/Localization";


const AddAutoLoaderConfigurationModal = (props) => {

    const {formatMessage} = props.intl;
    const {mac, intl} = props;
    const {getDraftData, addInstance, editInstance} = useContext(DraftContext)
    const installationType = getInstallationTypes(AUTO_LOADER_ASSET_TYPE);

    // Visual controls
    const {open, setOpen} = props
    const [show, setShow] = useState(false)
    const [edit, setEdit] = useState(false)
    const [showLocation, setShowLocation] = useState(true)

    // Values
    const [locations, setLocations] = useState("")
    const [type, setType] = useState("")
    const [destination, setDestination] = useState("")

    // Error
    const [locationsErr, setLocationsErr] = useState(false)
    const [typeErr, setTypeErr] = useState(false)
    const [destinationErr, setDestinationErr] = useState(false)

    const onCloseModal = () => {
        setShow(false);
        setOpen(false)
        resetInputState();
    }

    const modalAutoLoaderConfig = {
        destination: destination,
        installation: {
            type: type,
            locations: locations
        }
    }

    /* Filling a map: autoloaderConfigMap with Destination as key in case of an update of existing asset */
    const autoLoaderConfigMap = {}
    getDraftData({stateKey: CONFIG_TYPE.AUTOLOADER_DESTINATION, subKey: mac}).forEach(value => {
        const key = getAutoLoaderConfigKey(value.destination, value.installation.type);
        autoLoaderConfigMap[key] = {
            destination: value.destination,
            locations: value.installation.locations,
            type: value.installation.type,
        }
    });

    const onClickConfirm = (modalAutoLoaderConfig, mac) => {

        if (checkModalValidationsForConfig(modalAutoLoaderConfig, mac, AUTO_LOADER_ASSET_TYPE)) {
            setConfigData(modalAutoLoaderConfig, mac);
            setOpen(false)
            resetInputState();
            setShow(false);
        } else {
            setShow(true)
        }
    }

    function resetInputState() {
        setDestination("");
        setDestinationErr(false);
        setType("");
        setTypeErr(false);
        resetConfigDetails();
        resetConfigErrorDetails();
    }

    const resetConfigDetails = () => {
        setLocations("");
        setShowLocation(true);
    }

    const resetConfigErrorDetails = () => {
        setTypeErr(false);
        setLocationsErr(false);

    }


    const prefill = () => {
        const key = getAutoLoaderConfigKey(destination, type);
        console.log('Checking for existing config:', key, autoLoaderConfigMap);
        if (autoLoaderConfigMap.hasOwnProperty(key)) {
            setEdit(true);
            resetConfigErrorDetails();
            setLocations(getAutoLoaderConfigLocationStringForm(autoLoaderConfigMap[key].locations));
            setDestination(autoLoaderConfigMap[key].destination);
        } else if (edit) {
            setEdit(false);
            resetConfigDetails()
        }
    }

    const setConfigData = (modalAutoLoaderConfig, mac) => {
        if (CATCH_ALL_INSTALLATION_TYPES.includes(modalAutoLoaderConfig.installation.type)
            && modalAutoLoaderConfig.installation.locations.length === 0) {
            modalAutoLoaderConfig.installation.locations = [""];
        } else if (modalAutoLoaderConfig.installation.locations) {
            modalAutoLoaderConfig.installation.locations = modalAutoLoaderConfig.installation.locations
                .replace(/\s/g, '').split(';').filter(Boolean);
        } else {
            modalAutoLoaderConfig.installation.locations = [];
        }

        if(edit) {
            editInstance({
                stateKey: CONFIG_TYPE.AUTOLOADER_DESTINATION,
                subKey: mac,
                instance: modalAutoLoaderConfig,
                keyComparator: (config1, config2) => (
                    getAutoLoaderConfigKey(config1.destination, config1.installation.type) ===
                    getAutoLoaderConfigKey(config2.destination, config2.installation.type)
                ),
                valueComparator: (config1, config2) => (
                    JSON.stringify(config1.destination.locations) === JSON.stringify(config2.destination.locations) &&
                    JSON.stringify(config1.installation.locations) === JSON.stringify(config2.installation.locations)
                )
            });
        } else {
            addInstance({
                stateKey: CONFIG_TYPE.AUTOLOADER_DESTINATION,
                subKey: mac,
                instance: modalAutoLoaderConfig
            });
        }
    };

    const generateHelperText = () => {
        return CATCH_ALL_INSTALLATION_TYPES.includes(type)
            ? getLocalizedMessage({intl, stringId: "modal.optional.example"})
            : getLocalizedMessage({intl, stringId: "modal.location_example"});
    };


    return (
        <Row>
            <Modal
                title={formatMessage({id: "autoloaderconfig.addupdate"})}
                open={open}
                onClose={onCloseModal}
                scrollContainer="viewport"
                closeLabel="Close"
                bodySpacingInset="medium">
                <Column spacing={"medium"} spacingInset={"medium"}>
                    <Column spacing="200">
                        <b> {getLocalizedMessage({ intl, stringId: "modal.addheadingautoloader" })}
                        </b>
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            {getLocalizedMessage({intl, stringId: "destination.id"})}
                        </Text>
                        <Input id="destination-id-input"
                               value={destination}
                               onChange={setDestination}
                               onBlur={() => {
                                   setDestinationErr(!isValidEntry(destination, PATTERNS.DESTINATION))
                                   prefill();
                               }}
                               error={destinationErr}/>
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            {getLocalizedMessage({ intl, stringId: "modal.installationtype" })}
                        </Text>
                        <Select id="type-input"
                                value={type}
                                onChange={setType}
                                onBlur={() => {
                                    prefill();
                                }}
                                placeholder={getLocalizedMessage({ intl, stringId: "modal.enter_value" })}
                                width="100%"
                                error={typeErr}>
                            {Object.values(installationType).map(({label, value}, index) =>
                                <SelectOption key={index} value={value} label={label} />
                            )}
                        </Select>
                    </Column>
                    { showLocation && <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            { getLocalizedMessage({ intl, stringId: "modal.location" })}
                        </Text>
                        <Input id="location-input"
                               value={locations}
                               onChange={setLocations}
                               onBlur={() => {setLocationsErr(!(
                                   (type === INSTALLATION_TYPES.SIDELINE.value && isValidEntry(locations, PATTERNS.CATCH_ALL_LOCATION))
                                   || isValidEntry(locations, PATTERNS.LOCATION)
                               ))}}
                               error={locationsErr}
                               helperText={generateHelperText()}
                               />
                    </Column> }
                </Column>
                <ModalFooter>
                    <Column>
                        {!checkModalValidationsForConfig(modalAutoLoaderConfig, mac, AUTO_LOADER_ASSET_TYPE) &&
                            show &&
                            <Alert type="warning"
                                   size="small">
                                { getLocalizedMessage({ intl, stringId: "alert.missingfields" })}
                            </Alert>}
                    </Column>
                    <Row alignmentHorizontal="right" widths="fit">
                        <Button type="secondary" size="medium" onClick={onCloseModal}>
                            {getLocalizedMessage({ intl, stringId: "modal.cancel" })}
                        </Button>
                        <Button type="primary" size="medium"
                                onClick={() => onClickConfirm(modalAutoLoaderConfig, mac)}>
                            { edit ? getLocalizedMessage({ intl, stringId: "modal.confirmUpdate"})
                                : getLocalizedMessage({ intl, stringId: "modal.confirmAdd" })}
                        </Button>
                    </Row>
                </ModalFooter>
            </Modal>
        </Row>
    )
}

export default injectIntl(AddAutoLoaderConfigurationModal);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/autoloader/modal/AddAutoLoaderConfigurationModal.js